const ProductRecommendedPosition = {
  EVERYWHERE: 'EVERYWHERE',
  CATEGORY: 'CATEGORY',
  FRONTPAGE: 'FRONTPAGE'
};

export default ProductRecommendedPosition;
